import wooshSound from '../../../public/sfx/woosh.mp3'

const wooshSoundInstance = new Audio(wooshSound);
wooshSoundInstance.volume = 0.8;

export default wooshSoundInstance;